import React, { Fragment,useState,useEffect } from 'react';
 
import Scrollbar from '../../components/scrollbar'
import { useParams } from 'react-router-dom'
import "bootstrap-icons/font/bootstrap-icons.css"
import RelatedProject from './related';
 import Logo from '../../images/logo.svg'
import Footer from '../../components/footer';
import Navbar2 from '../../components/Navbar2'
import SliderProject from '../../components/SliderProject';
import { doc, getDoc,db } from '../../api/firebaseConfig';
import { Helmet } from 'react-helmet-async';
          
const ProjectSinglePageArenover = (props) => {
    const { id } = useParams()
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(!showModal);

    const [imagesLoaded, setImagesLoaded] = useState(false); // Track image loading state

    const [post, setPost] = useState(null);
   




    useEffect(() => {
        const fetchPostDetail = async () => {
          try {
            const docRef = doc(db, "blogPostsRiadArenover", id); // Reference to the specific post
            const docSnap = await getDoc(docRef);
            
            if (docSnap.exists()) {
              setPost(docSnap.data()); // Set the post data in state
              
            } else {
              console.log("No such document!");
            }
          } catch (error) {
            console.error("Error fetching post details: ", error);
          }
        };
    
        fetchPostDetail();
         
      }, [id]); // Re-run when the ID changes
      useEffect(() => {
        if (post) {
            const images = [...post.imagecarrousel, post.imageprincipale];
            const totalImages = images.length;
            let loadedImages = 0;

            // Check if images are loaded
            const onImageLoad = () => {
                loadedImages++;
                if (loadedImages === totalImages) {
                    setImagesLoaded(true); // All images are loaded
                }
            };

            images.forEach((imageUrl) => {
                const img = new Image();
                img.src = imageUrl;
                img.onload = onImageLoad;
            });
        }
    }, [post]);
      

     


    // const projectDetails = Projects.find(item => item.Id === id)
    if (!post || !imagesLoaded) return <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100vh' }}>
    <img src={Logo} alt="Logo" style={{ width: '100px', marginBottom: '20px' }} />
    <div className="spinner-border text-warning" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>

    
    return (
        <Fragment>
            <Helmet>
      <title>{post.title} - Get Riad</title>
      <meta name="description" content={post.description} />
      <meta name="keywords" content="Riads, Morocco, Hotels, Travel, Marrakech, Luxury Riads in Marrakech, Best Riads in Morocco, Affordable Riads in Marrakech, Marrakech Hotels, Traditional Moroccan Riads, Morocco Travel Guide, Stay in a Riad Marrakech, Riad Renovation Marrakech, Boutique Hotels Marrakech, Luxury Hotels Marrakech, Best Places to Stay in Morocco, Moroccan Hotels with Pool, Exploring Marrakech Riads, Authentic Morocco Travel, Top Hotels in Marrakech, Riad Accommodation Marrakech, Marrakech Travel Deals, Best Riads for Families in Marrakech, Morocco Vacation Packages, Marrakech City Tours and Riads, Hidden Gems in Marrakech, Morocco Honeymoon Packages, Traditional Moroccan Accommodation, Book Riads in Marrakech Online, Marrakech Boutique Hotels with Character" />

      <meta property="og:title" content={post.title} />
      <meta property="og:description" content={post.description} />
      <meta property="og:image" content={post.imageprincipale} />
    </Helmet>
<Navbar2 Logo={Logo} hclass={'wpo-header-style-3'}/>
           
           { /*<PageTitle pageTitle={projectDetails.title} pagesub={'Project'} /> */}

            <SliderProject key={1} isCarrousel={true} title={post.title} imagecarrousel={post.imagecarrousel}  />
            <div className="wpo-project-single-area mt-3 ">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-12">
                            <div className="wpo-project-single-wrap">
                                <div className="wpo-project-single-item">
                                    <div className="row align-items-center">
                                        <div className="row">
                                            <div className="wpo-project-single-title">
                                                <h3>{post.title}</h3>
                                                <div className="d-flex flex-wrap align-items-center gap-4">
  <div className="d-flex align-items-center">
    <i className="bi bi-cash-stack me-2" style={{ color: '#ff8051', fontSize: '1.2rem' }}></i>
    <span className="fw-bold" style={{ color: '#0D0845', fontSize: '1.1rem' }}>
      {post.prix} €
    </span>
  </div>
  <div className="d-flex align-items-center">
    <i className="bi bi-rulers me-2" style={{ color: '#ff8051', fontSize: '1.2rem' }}></i>
    <span className="fw-bold" style={{ color: '#0D0845', fontSize: '1.1rem' }}>
      {post.metrage} m²
    </span>
  </div>
  <div className="d-flex align-items-center">
    <i className="bi bi-calendar-event me-2" style={{ color: '#ff8051', fontSize: '1.2rem' }}></i>
    <span className="fw-bold" style={{ color: '#0D0845', fontSize: '1.1rem' }}>
      {post.dateRiad}
    </span>
  </div>
</div>

                                            </div>
                                             
                                            <p>
       
        {post.description}
      </p>

     

       
                                            { /* <p>{projectDetails.section1.description1}</p> */}
                                            </div>
                                        
                                    </div>
                                    <div className="wpo-project-single-main-img">
                                        <center>
                                        <img src={post.imageprincipale} width={"100%"}  alt={post.title}/>
                                        </center>
                                        
                                    </div>
                                    {/* <div className=" ">
                                        <div className="row">
                                        <div className=" ">
                                                <div className="wpo-project-single-title">
                                                    <h3>Les Séjours</h3>
                                                </div>
                                                <SliderProject key={2} isCarrousel={false} title={`les chambres de nuit du ${post.title}`} imagecarrousel={post.zoneSpecifique.salon}  />
                                            </div>
                                            <div className=" ">
                                                <div className="wpo-project-single-title  mt-4">
                                                    <h3>Les Chambres De Nuit</h3>
                                                </div>
                                                <SliderProject key={2} isCarrousel={false} title={`les chambres de nuit du ${post.title}`} imagecarrousel={post.zoneSpecifique.chambreDeNuit}  />
                                            </div>
                                            
                                        </div>
                                    </div> */}
                                    {/* <div className=" ">
                                        <div className="row">

                                      

                                            <div className=" ">
                                                <div className="wpo-project-single-title mt-4">
                                                    <h3>Les Salles de Bain</h3>
                                                </div>
                                                <SliderProject key={2} isCarrousel={false} title={`les chambres de nuit du ${post.title}`} imagecarrousel={post.zoneSpecifique.salleDeBain}  />
                                            </div>
                                             
                                            <div className="d-flex justify-content-center">
                                            <div className="col-lg-7 mt-4 mb-4">
                                                <div className="wpo-project-single-item-quote">
                                                <div className="wpo-project-single-title">
                                                    <h3>Ce que propose ce Riad</h3>
                                                </div>
                                                <div className="d-flex justify-content-center">
                                                <ul className="list-unstyled mt-3">
  {Object.entries(post.amenities)
    .sort(([, a], [, b]) => b - a) // Sort: true values first, then false
    .map(([key, value]) => {
      const amenityLabels = {
        caméras: "Caméras de surveillance",
        climatisation: "Climatisation",
        cuisine: "Cuisine équipée",
        detecteurFumee: "Détecteur de fumée",
        detecteurMonoxyde: "Détecteur de monoxyde de carbone",
        laveLinge: "Lave-linge",
        piscine: "Piscine",
        tv: "Télévision",
        wifi: "Wi-Fi",
      };

      return (
        <li key={key} className="d-flex align-items-center mb-2">
          <i className={`bi ${amenityIcons[key]} me-2`} />
          <span className={value ? "" : "text-decoration-line-through"}>
            {amenityLabels[key]}
          </span>
        </li>
      );
    })}
</ul>
</div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    
                                    <section className="wpo-contact-map-section">
                                    <div className="wpo-project-single-title mt-4">
                                                    <h3>Où se trouve ce Riad?</h3>
                                                </div>
                <div className="wpo-contact-map">
                 
                                                   
                                                
                    <iframe 
                        src={post.location}  
                        title={`Localisation de ${post.title}`}
                        width="600" 
                        height="450" 
                        style={{ border: "0" }}  
                        allowFullScreen  
                        loading="lazy"  
                        referrerPolicy="no-referrer-when-downgrade">
                    </iframe>
            </div>
            </section>
                                    
                                     <div className='mt-4'>
                                    <RelatedProject/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer ftClass={'wpo-site-footer-s2'}/>
            <Scrollbar />
        </Fragment>
    )
};
export default ProjectSinglePageArenover;
